import { LogOut } from 'lucide-react';
import { useUser, useUserSession } from '@/contexts/UserSession';

const LogoutFooter = () => {
    const { logout } = useUserSession();
    const user = useUser(true);

    return (
        <div className="bg-default-50 dark:bg-default-200 mt-5 flex items-center gap-3 px-4 py-2">
            <div className="flex-1">
                <div className="text-default-700 mb-0.5 truncate text-sm font-semibold capitalize">{user?.name}</div>
                <div className="text-default-600 truncate text-xs">{user?.email}</div>
            </div>
            <div className="flex-none">
                <button
                    type="button"
                    onClick={() => logout()}
                    className="text-default-500 dark:bg-default-300 dark:text-default-900 inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded"
                >
                    <LogOut className="h-5 w-5" />
                </button>
            </div>
        </div>
    );
};

export default LogoutFooter;
